import React from "react";
import Modal from "./modal";

export default function DiagnosticModal({ show, onResult, onClose }) {
  return (
    <Modal show={show} onClose={onClose}>
      <h2>Diagnostic Oestrus</h2>
      <button
        style={{ padding: "10px", margin: "10px" }}
        onClick={() => onResult("positif")}
      >
        Positif 
      </button>

      <button
        style={{ padding: "10px", margin: "10px" }}
        onClick={() => onResult("negatif")}
      >
        Négatif 
      </button>
    </Modal>
  );
}
